import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { dashboardLayoutDataFactory } from './services/dashboardDataFactory';
import { ShamDashboardData } from 'sham-components/features/dashboard';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'sham-components/services';
import { ToastOutlet } from './shared/toast-outlet/toast-outlet';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App implements OnInit {
  private langService = inject(LanguageService);
  private translate = inject(TranslateService);
  private dashData = inject(ShamDashboardData);

  constructor() {
    // Listen for language changes and update the dashboard layout
    this.translate.onLangChange.subscribe(() => {
      dashboardLayoutDataFactory(this.dashData, this.translate);
    });
  }

  ngOnInit(): void {
    this.langService.init();
    // In case it was already loaded or to ensure it's set initially
    if (this.translate.currentLang) {
      dashboardLayoutDataFactory(this.dashData, this.translate);
    }
  }
  protected readonly title = signal('admin-delivery');
}
